module.exports = __webpack_public_path__ + "static/img/5.5682291.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/5.png
// module id = ijhf
// module chunks = 0